<template>
	<div :class="rootClass">
		<strong class="tit_view"><em class="txt_point">지난주,</em> 카페 인기글</strong>
		<ul class="list_hotview" id="list_hotview" ref="articleElementsWrapper">
			<card-item v-for="article in renderedArticles" :article="article" :feedback="feedback" :config="config" ref="articleElements"></card-item>
		</ul>
		<div class="wrap_btn">
			<button type="button" class="btn_item btn_moreview" @click="renderMoreArticles" v-if="renderedArticleCount < articles.length">더보기</button>
		</div>
	</div>
</template>

<script>
import CardItem from './CardItem.vue';
import adfitNativeAds from '@src/native-ad.js';
import { addVimps } from '../tesla-queue.js';

export default {
	components: {
		CardItem
	},
	props: {
		config: Object,
		articles: {
			type: Array,
			default: () => ([])
		},
		feedback: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			MORE_VIEW_SIZE: 10,
			renderedArticleCount: 10,

			MAX_AD_COUNT: 10,
			AD_COUNT_PER_PAGE: 2,
			ads: [],
			page: 0
		};
	},
	computed: {
		rootClass() {
			return {
				'view_card': true,
				'view_hotview': true,
				'view_card--no_contents': this.articles.length === 0
			};
		},
		renderedArticles() {
			return this.newArticles.slice(0, this.renderedArticleCount);
		},
		localStorageSupport() {
			let support = typeof localStorage !== 'undefined';
			try {
				localStorage.setItem('_', '');
			} catch (e) {
				support = false;
			}
			return support;
		},
		skipCount() {
			if (document.referrer !== '' || !this.localStorageSupport) {
				return 0;
			}
			let index = localStorage.getItem('nextSkip') || 0;
			index = parseInt(index);
			if (index === 0 || index > this.articles.length) {
				localStorage.setItem('nextSkip', '6');
				return 0;
			}
			localStorage.setItem('nextSkip', (index + 6).toString());
			return index;
		},
		newArticles() {
			let newArticles = [...this.articles];
			const skippedArticles = newArticles.splice(0, this.skipCount);
			return [...newArticles, ...skippedArticles];
		}
	},
	methods: {
		renderMoreArticles() {
			this.renderedArticleCount += this.MORE_VIEW_SIZE;
			if (this.renderedArticleCount > this.newArticles.length) {
				this.renderedArticleCount = this.newArticles.length;
			}

			this.$nextTick(() => {
				this.appendAdfitNativeAds();
				this._observeCards();
			});
		},
		fetchAdfitNativeAds() {
			adfitNativeAds(this.config.svcParam, this.MAX_AD_COUNT, ads => {
				this.ads = ads;
				this.appendAdfitNativeAds();
			}).init();
		},
		appendAdfitNativeAds() {
			const adPositionMap = {
				0: 2,
				1: 8
			}

			this.ads.splice(0, this.AD_COUNT_PER_PAGE).forEach((ad, idx) => {
				const position = this.page * this.MORE_VIEW_SIZE + adPositionMap[idx];
				const content = this.$refs.articleElements[position]?.$el;

				if (content) {
					this.$refs.articleElementsWrapper.insertBefore(ad, content);
				}
			});

			this.page++;
		},
		_setupViewImpTracking() {
			if (typeof IntersectionObserver === 'undefined') return;

			this._viewImpContents = []; // tiara 로그 전송용: view impression 이벤트를 pagehide 시점에 한 번 보내기 위한 버퍼
			this._observer = new IntersectionObserver((entries) => {
				const newItemIds = []; // tesla 본거빼기 기능용: observer callback에서 새로 보인 item만 queue에 반영하기 위한 입력
				entries.forEach(entry => {
					//관찰대상 교차 상태가 false(보이지않는) 경우 실행하지 않음
					if (!entry.isIntersecting) return;
					this._observer.unobserve(entry.target);
					const itemId = entry.target.dataset.viewImpId;
					
					newItemIds.push(itemId);
					this._viewImpContents.push({
						id: itemId,
						imp_extra_info: entry.target.dataset.teslaFeedback
					});
				});
				newItemIds.length && addVimps(newItemIds); // localStorage 저장
			}, { threshold: 0.5 });

			//bfcache문제로 beforeunload -> pagehide/pageshow 이벤트로 변경
			this._onPageHide = () => this._flushViewImp();
			this._onPageShow = (e) => { if (e.persisted) this._resetObservation(); };
			window.addEventListener('pagehide', this._onPageHide);
			window.addEventListener('pageshow', this._onPageShow);

			this._observeCards();
		},
		_flushViewImp() { // 실제 viewImpression 이벤트 전송
			if (!this._viewImpContents.length) return;
			this.$trackViewImp({
				page: 'hot_article_view',
				pageName: '인기글뷰',
				layerName: '인기글카드',
				contents: this._viewImpContents,
				customProps: this.feedback || {}
			});
			this._viewImpContents = [];
		},
		_resetObservation() {
			this._viewImpContents = [];
			const wrapper = this.$refs.articleElementsWrapper;
			if (wrapper) {
				wrapper.querySelectorAll('.hotview_wrap[data-observed]').forEach(el => delete el.dataset.observed);
			}
			this._observeCards();
		},
		_observeCards() {
			if (!this._observer) return;
			const wrapper = this.$refs.articleElementsWrapper;
			if (!wrapper) return;
			//광고카드 제외, 인기글카드만
			wrapper.querySelectorAll('li:not([adfit-unit-id]) .hotview_wrap:not([data-observed])').forEach(el => {
				el.dataset.observed = 'true';
				this._observer.observe(el);
			});
		}
	},
	mounted() {
		this.fetchAdfitNativeAds();
		this._setupViewImpTracking();
	},
	beforeDestroy() {
		if (this._observer) this._observer.disconnect();
		if (this._onPageHide) window.removeEventListener('pagehide', this._onPageHide);
		if (this._onPageShow) window.removeEventListener('pageshow', this._onPageShow);
	}
}
</script>
